import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { AuthState } from "./auth.type";
import { Role } from "@app/constants";
import { User } from "@app/types";

const initialState: AuthState = {
  id: 0,
  bookasId: "",
  email: "",
  username: "",
  fullName: "",
  phone: "",
  role: Role.USER,
  thumbnail: "",
  isVip: false,
  point: 0,
  expiredDateVip: "",
  categoryIds: [],
  totalListenedTime: "",
  barge: {
    name: "",
    nameNextBarge: "",
    progress: 0,
    thumbnail: "",
    thumbnailNextBarge: "",
  },
  linkAffiliate: "",
};

const authSlice = createSlice({
  name: "@auth",
  initialState,
  reducers: {
    storeUser(state, action: PayloadAction<User>) {
      state.id = action.payload.id;
      state.email = action.payload.email;
      state.username = action.payload.username;
      state.fullName = action.payload.fullName;
      state.phone = action.payload.phone;
      state.role = action.payload.role;
      state.thumbnail = action.payload.thumbnail;
      state.isVip = action.payload.isVip;
      state.point = action.payload.point;
      state.expiredDateVip = action.payload.expiredDateVip;
      state.categoryIds =
        action.payload.categories?.map((item) => item.id) ?? [];
      state.totalListenedTime =
        action.payload?.activities?.book?.totalTime ?? "";
      state.barge = action.payload.barge;
      state.bookasId = action.payload.bookasId;
      state.linkAffiliate = action.payload.linkAffiliate;
    },
    clearUser: () => initialState,
  },
});

export const { storeUser, clearUser } = authSlice.actions;

export default authSlice.reducer;
